<script>
import resources from './resources'

export default {
  name: 'favorite-list-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Meus Médicos", icon="")
    .col-xs-12.content
      .container-fluid.zero-margin
        .row
        .row(v-if="loading")
          spinner(:show="true")
        .row(v-if="!loading")
          section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget(v-if="favoriteListes.length  <= 0", style="margin-top: 30px;")
            .actions
            div.text-center
              h2.center
                br
                |Ainda não existem médicos selecionados como favorito.
          .list-item-full.white-bg(v-for="favoriteList in favoriteListes", v-if="favoriteListes.length > 0")
              .col-md-3
                .profile-photo
                  img.img-circle(:src="favoriteList.professional.avatar")

              .col-md-4
                .row
                  h4 {{ favoriteList.professional.name}}
                  span.crm CRM {{ favoriteList.professional.document }} &mdash; {{ favoriteList.professional.state }}
                .row.m-t-20
                  h4 Especialidades
                  .planos
                    span(v-for="speciality in favoriteList.professional.speciality")
                      | {{ speciality.label }}

              .col-md-4
                 a.btn.btn-primary.pull-right(@click.prevent="doSearchByProfessionalFavorite(favoriteList)")
                  i.fa.fa-calendar &nbsp; &nbsp;
                   | Agendar

              .col-md-1
                .exclude-list(@click.prevent="doDelete(favoriteList)")
                  span.icon 

        .pagination.m-b-50
          pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>
<style scoped>
.list-item-full {
    height: auto;
    min-height: 179px;
    margin: 1% 1% 1% 1%;
    float: left;
    padding: 15px;
    position: relative;
    overflow: hidden;
    border: 1px solid #e5e7e7;
}
  .list-item-full h4 {
      margin: 2px 0px;
  }
  .m-t-20 {
    margin-top: 20px;
  }
  .pagination {
      width: 100%;
      margin: 0;
      margin-bottom: 50px;
  }
  .m-b-50 {
    margin-bottom: 50px;
  }
 .profile-photo img {
    width: 60%;
    margin: 0px 0%;
  }
  .h4 {
      color: #387ab9;
  }
  .results .item h4 {
      font-size: 18px;
      margin-top: 45px;
  }
  .crm{
      font-weight: bold;
      color: #898989;
      font-size: 1.0em;
  }
  .speciality {
      font-weight: bold;
      color: #898989;
      font-size: 1.0em;
  }
  .planos {
    margin-top: 0px;
  }
  .planos span {
      display: inline-block;
      margin: 3px 2px;
      padding: 2px 15px;
      border: 1px solid #1384D8;
      color: #1384D8;
      border-radius: 50px;
      cursor: default;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/favorite-list/index/index.vue